<template>
	<div class="home-page" :style="{ height: $pageHeight() + 'px' }">
		<topBar :scheduleMode="'calendar'" @switchScheduleMode="switchScheduleMode" @showHideHomeMenu="showHideHomeMenu"
			:userId="userId" @showHideSearchBar="showHideSearchBar"></topBar>
		<div class="home">
			<div class="home-menu" v-show="isShowHomeMenu">
				<memberMenu :memberList="memberList" :userId="userId" :viewUserId="viewUserId">
				</memberMenu>
			</div>
			<div class="home-schedule">
				<div class="home-schedule-calendar">
					<scheduleBar :memberList="memberList" :switchMode="1"></scheduleBar>
					<div class="schedule-calendar">
						<scheduleCalendar :memberList="memberList" :viewUserId="viewUserId" :userId="userId">
						</scheduleCalendar>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import topBar from '../../components/common/TopBar.vue';
	import memberMenu from '../../components/common/MemberMenu.vue';
	import scheduleBar from '../../components/tools/ScheduleBar.vue';
	import scheduleCalendar from '../../components/schedule/ScheduleCalendar.vue';
	export default {
		components: {
			topBar,
			memberMenu,
			scheduleBar,
			scheduleCalendar
		},
		props: {},
		data() {
			return {
				memberList: [], //人员管理列表
				isShowHomeMenu: true, //是否显示首页左侧菜单栏
				userId: -1, //当前登录用户Id
				viewUserId: -1, //要查看的用户Id
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				let userInfo = JSON.parse(localStorage.getItem('userInfo'));
				that.userId = userInfo.id;
				that.viewUserId = that.userId;
				that.getServicePersonInfo();
				that.$bus.$on('selectViewUser', (userInfo) => {
					let that = this;
					if (userInfo) {
						that.viewUserId = userInfo.id;
					} else {
						that.viewUserId = that.userId;
					}
				})
			})
		},
		methods: {
			//获取当前用户服务对象列表
			getServicePersonInfo() {
				let that = this;
				let params = {
					userId: that.userId
				};
				that.$api.getServicePersonInfo(params).then(res => {
					// console.log(res)
					if (res.code == 1) {
						res.data.forEach((item, index) => {
							item.isSelected = false;
						});
						res.data = res.data.filter(item => {
							return item.id != that.userId
						});
						that.memberList = res.data;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//点击展示隐藏首页左侧菜单栏
			showHideHomeMenu(isShowHomeMenu) {
				let that = this;
				that.isShowHomeMenu = isShowHomeMenu;
			},
			//点击切换日程显示模式
			switchScheduleMode() {
				let that = this;
				that.$router.replace("/listModeSchedule");
			},
			//点击显示隐藏搜索栏
			showHideSearchBar() {
				let that = this;
				that.$router.replace({
					name: "ListModeSchedule",
					params: {
						isShowSearchBar: true
					}
				});
			}
		}
	}
</script>

<style lang="scss">
	.home {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
	}

	.home-menu {
		height: 100%;
	}

	.home-schedule {
		width: 100%;
		box-sizing: border-box;

		.home-schedule-calendar {
			.schedule-calendar {}
		}
	}

	@media screen and (min-width: 1024px) {
		.home {
			height: calc(100% - 47px);
		}
		.home-schedule {
			.home-schedule-calendar {
				padding: 16px 19px 20px 20px;
		
				.schedule-calendar {
					margin: 30px 0 0;
				}
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.home {
			height: calc(100% - 78px);
		}

		.home-schedule {
			.home-schedule-calendar {
				padding: 12px 17px 12px 12px;

				.schedule-calendar {
					margin: 20px 0 0;
				}
			}
		}
	}

	@media screen and (min-width: 1920px) {
		.home {
			height: calc(100% - 90px);
		}
	}
</style>